exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#page9 #box[data-v-10cc5a3e] {\n}\n", ""]);
